document.addEventListener("DOMContentLoaded", function() {
  const bosAlanlar = document.querySelectorAll('.bilesen-aciklama');
  if (bosAlanlar.length === 0) return;

  function shopifyHandleize(str) {
    if (!str) return '';
    const turkishChars = {
      'ç':'c', 'ğ':'g', 'ı':'i', 'ö':'o', 'ş':'s', 'ü':'u',
      'Ç':'c', 'Ğ':'g', 'İ':'i', 'Ö':'o', 'Ş':'s', 'Ü':'u'
    };
    let mapped = str.split('').map(char => turkishChars[char] || char).join('');
    return mapped.toLowerCase()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
  }

  function getCoreHandle(str) {
    if (!str) return '';
    const firstPart = str.split(/[\/\(\[]/)[0].trim();
    return shopifyHandleize(firstPart);
  }

  const jsonUrl = window.shopify_etken_maddeler_url || 'etken-maddeler.json';

  fetch(jsonUrl)
    .then(response => {
      if (!response.ok) throw new Error("JSON yüklenemedi");
      return response.json();
    })
    .then(excelData => {
      const veriHaritasi = {};
      
      const ilkSatirKeys = Object.keys(excelData[0]);
      const tagKey = ilkSatirKeys.find(k => 
        k.toLowerCase().includes('tag') || 
        k.toLowerCase().includes('bilesen') || 
        k.toLowerCase().includes('bileşen')
      ) || ilkSatirKeys[0];

      const descKey = ilkSatirKeys.find(k => 
        k.toLowerCase().includes('aciklama') || 
        k.toLowerCase().includes('açıklama') || 
        k.toLowerCase().includes('evla')
      ) || ilkSatirKeys[1];

      excelData.forEach(satir => {
        const rawTag = satir[tagKey];
        const rawDesc = satir[descKey];
        if (rawTag) {
          const coreHandle = getCoreHandle(rawTag);
          const fullHandle = shopifyHandleize(rawTag);
          
          veriHaritasi[coreHandle] = rawDesc;
          veriHaritasi[fullHandle] = rawDesc;
        }
      });

      // Eşleştirme ve Önceliklendirme İşlemi
      bosAlanlar.forEach(el => {
        const rawTag = el.getAttribute('data-raw-tag') || el.getAttribute('data-tag');
        const coreHandle = getCoreHandle(rawTag);
        const fullHandle = shopifyHandleize(rawTag);

        // JSON dosyasından güncel açıklamayı al
        const guncelAciklama = veriHaritasi[coreHandle] || veriHaritasi[fullHandle];

        if (guncelAciklama) {
          // 1. ÖNCELİK: JSON'da veri varsa, eski sayfa olsa bile üzerine yaz
          el.innerHTML = guncelAciklama;
        } else {
          // 2. ÖNCELİK (YEDEK): JSON'da veri yoksa ve şu anki içerik boş/üç nokta ise uyarı ver
          // Eğer halihazırda Shopify sayfa içeriği yüklenmişse ona dokunma (koru)
          const mevcutIcerik = el.innerHTML.trim();
          if (mevcutIcerik === '...' || mevcutIcerik === '') {
            el.innerHTML = "Bileşen açıklaması bulunamadı.";
          }
        }
      });
    })
    .catch(err => {
      console.error("Hata:", err);
    });
});